import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';

export interface AdminReferral {
  id: string;
  userId: string | null;
  telegramId: string;
  code: string;
  referredCount: number;
  totalRevenue: number;
  isAgent: boolean;
  rewardAmount: number | null;
  enabled: boolean;
  displayName: string;
  createdAt: string;
  updatedAt: string;
}

export interface ReferralStats {
  total: number;
  agents: number;
  users: number;
  totalSignups: number;
  totalPaid: number;
}

export interface Pagination {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

class AdminReferralService {
  async list(params: {
    page?: number;
    limit?: number;
    search?: string;
    tier?: 'all' | 'user' | 'agent';
  }): Promise<{ referrals: AdminReferral[]; pagination: Pagination }> {
    const res = await apiClient.get<
      ApiEnvelope<{ referrals: AdminReferral[]; pagination: Pagination }>
    >(API_ENDPOINTS.REFERRALS.LIST, { params });
    return res.data.data;
  }

  async stats(): Promise<ReferralStats> {
    const res = await apiClient.get<ApiEnvelope<ReferralStats>>(
      API_ENDPOINTS.REFERRALS.STATS
    );
    return res.data.data;
  }

  async createAgent(input: {
    telegramId: string;
    rewardAmount?: number | null;
  }): Promise<AdminReferral> {
    const res = await apiClient.post<ApiEnvelope<AdminReferral>>(
      API_ENDPOINTS.REFERRALS.CREATE_AGENT,
      input
    );
    return res.data.data;
  }

  async update(
    id: string,
    input: {
      rewardAmount?: number | null;
      enabled?: boolean;
      isAgent?: boolean;
    }
  ): Promise<AdminReferral> {
    const res = await apiClient.put<ApiEnvelope<AdminReferral>>(
      API_ENDPOINTS.REFERRALS.UPDATE(id),
      input
    );
    return res.data.data;
  }

  async demote(id: string): Promise<AdminReferral> {
    const res = await apiClient.post<ApiEnvelope<AdminReferral>>(
      API_ENDPOINTS.REFERRALS.DEMOTE(id)
    );
    return res.data.data;
  }

  async toggleEnabled(id: string): Promise<{ id: string; enabled: boolean }> {
    const res = await apiClient.patch<
      ApiEnvelope<{ id: string; enabled: boolean }>
    >(API_ENDPOINTS.REFERRALS.TOGGLE_ENABLED(id));
    return res.data.data;
  }
}

const adminReferralService = new AdminReferralService();
export default adminReferralService;